import React from "react";
import { PublicRoutes } from "../routes/PublicRoutes";

export const Main = () => {
    return (
        <PublicRoutes />
    )
}